// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".is-loading[data-v-7e668ea6]{min-height:250px}.mcp-admin-merchant-details-section[data-v-7e668ea6]{border-bottom:1px solid #d1d1d1}.mcp-admin-merchant-details-section__header[data-v-7e668ea6] div.v-application--wrap{margin-top:0;min-height:auto}", ""]);
// Exports
module.exports = exports;
